export const patientInitialState = {
    id: "",
    upid: "",
    createByUserId: "",
    firstName: "",
    middleName: "",
    age: "",
    lastName: "",
    email: "",
    address: "",
    adharNumber: "",
    locationId: "",
    gender: "",
    phone: "",
    homePhone: null,
    tempAddress: "",
    tempCity: "",
    tempState: "",
    tempZip: "",
    tempAddrSameAsPermanent: false,
    companyId: "",
    dob: "",
    preferredLanguage: "",
    maritalStatus: "",
    race: "",
    ethnicity: "",
    isSelfGuarantor: true,
    partnerId: "",
    guarantorId: null,
    referralId: "",
    insuranceId: "",
    profileImageId: null,
    externalPatientId: null,
    examinationId: null,
    patientMPI: null,
    patientBMI: null,
    partnerMPI: null,
    partnerBMI: null,
    createdAt: "",
    updatedAt: "",
    userId: null,
    location: {
      city: "",
      state: "",
      zip: ""
    },
    guarantor: {
      id: null,
      name: null,
      phoneNumber: null,
      address: null,
      city: null,
      relationship: null,
      createdAt: null,
      updatedAt: null
    },
    referral: {
      id: "",
      referringPhysician: "",
      referringPhysicianPhone: "",
      referringPhysicianAddress: "",
      appliedThrough: "",
      createdAt: "",
      updatedAt: ""
    },
    company: {
      id: "",
      name: "",
      occupation: "",
      email: "",
      createdAt: "",
      updatedAt: ""
    },
    partner: {
      id: "",
      firstName: "",
      middleName: "",
      homePhone: "",
      lastName: "",
      maritalStatus: "",
      occupation: "",
      email: "",
      address: "",
      gender: "",
      dob: "",
      phone: "",
      adharNumber: "",
      locationId: "",
      preferredLanguage: "",
      relationWithPatient: "",
      partnerAddrSameAsSelf: false,
      profileImageId: null,
      createdAt: "",
      updatedAt: "",
      location: {
        id: "",
        city: "",
        state: "",
        zip: ""
      }
    },
    insurance: {
      id: "",
      companyName: "",
      policyNumber: "",
      groupNumber: "",
      claimAddress: "",
      locationId: "",
      phoneNumber: "",
      city: "",
      state: "",
      zip: "",
      subscriberName: "",
      relationshipToSubscriber: "",
      policyType: "",
      createdAt: "",
      updatedAt: ""
    },
    infertilityDetails: {
      id: "",
      patientId: "",
      infertilityType: "",
      priSec: "",
      causeOfInfertilityType: [],
      infertilityComment: "",
      createdAt: "",
      updatedAt: ""
    },
    histories: {
      id: null,
      createByUserId: null,
      patientId: null,
      history: null,
      createdAt: null,
      updatedAt: null
    },
    treatmentPlans: {
      id: null,
      patientId: null,
      createByUserId: null,
      treatmentPlan: null,
      createdAt: null,
      updatedAt: null
    },
    examinations: {
      id: null,
      patientId: null,
      evalutionOfMalePartner: null,
      examinationOfFemalePartner: null,
      examinationOfMalePartner: null,
      investigationOfFemalePartner: null,
      createdAt: null,
      updatedAt: null
    },
    cycles: {},
    profileImagePresignedUrl: null,
    partnerProfileImagePresignedUrl: null,
    patientCycles: [],
    hsa : [],
    qsa: [],
    dfi: []
  };